import { t } from "@/i18n-js/instance";
import { useSelectedBlock } from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { Icon } from "@circle-react-shared/Icon";
import { BlockActionButton } from "./BlockActionButton";

export const Remove = () => {
  const { isDeletable, removeSelectedBlock } = useSelectedBlock();

  const onClickHandler = () => {
    // TODO: Add confirmation modal
    removeSelectedBlock();
  };

  return (
    <BlockActionButton
      onClick={onClickHandler}
      disabled={!isDeletable}
      title={t("builder_ui.editor.remove")}
    >
      <Icon type="16-trash" size={16} />
    </BlockActionButton>
  );
};
